import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { superbillTasksActions } from 'features/superbillTasks';

const useSuperbillTasks = () => {
  const dispatch = useDispatch();
  const getSuperbillTasks = useCallback(({ id, offset }) => dispatch(superbillTasksActions.getSuperbillTasks({ id, offset })), [dispatch]);
  const getSuperbillTask = useCallback(id => dispatch(superbillTasksActions.getSuperbillTask(id)), [dispatch]);
  const clearLocalSuperbillTasks = useCallback(() => dispatch(superbillTasksActions.clearLocalSuperbillTasks()), [dispatch]);
  const clearLocalActiveSuperbillTask = useCallback(() => dispatch(superbillTasksActions.clearLocalActiveSuperbillTask()), [dispatch]);

  return {
    getSuperbillTasks,
    getSuperbillTask,
    clearLocalSuperbillTasks,
    clearLocalActiveSuperbillTask
  };
};

export default useSuperbillTasks;